import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { type AppDispatch, type AppState } from "../../../../store";
import {
  getOfferResponseById,
  downloadFile,
  rateOfferResponse,
  updateOfferResponse,
  generateOrder,
  generateInvoice,
} from "../../modules/actions";
import { getRequestById } from "../../../OfferRequests/modules/actions";

const mapStateToProps = (state: AppState) => ({
  state: {
    currentOfferResponse: state.offerResponseReducer.currentOfferResponse,
    currentOfferRequest: state.offerRequestReducer.currentOfferRequest,
    loggedUser: state.authReducer.loggedUser,
  },
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators(
    {
      getOfferResponseById,
      downloadFile,
      getRequestById,
      rateOfferResponse,
      updateOfferResponse,
      generateOrder,
      generateInvoice,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
